// removed by extract-text-webpack-plugin
module.exports = {"accountDetails":"AccountDetails__accountDetails___3Zwky","message":"AccountDetails__message___1NqPW","account-inputs":"AccountDetails__account-inputs___3LweY","buttonContainer":"AccountDetails__buttonContainer___28oKz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountDetails/AccountDetails.css
// module id = 691
// module chunks = 0